module.exports = __webpack_public_path__ + "static/img/case_detail_02_3.e77d5af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_02_3.png
// module id = z4sT
// module chunks = 34